import { formatBlank } from 'src/front/common/utils/formUtils';
import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const CardReissueSchema = Yup.object().shape({
  cardStatus: Yup.object().nullable().required('general_requiredField_errorMessage'),
  cardSubStatus: Yup.object().nullable(),
  cardReasonForReissue: Yup.object().nullable().required('general_requiredField_errorMessage'),
  embossedName: Yup.string().required('general_requiredField_errorMessage'),
  monthlyIncome: Yup.string().when(
    'showIncomeLabels',
    (showIncomeLabels: Yup.BooleanSchema, schema: Yup.StringSchema) =>
      showIncomeLabels
        ? schema
            .test(
              'isZero',
              'cardReissue_incomeFill_errorMessage',
              (value) => Number(formatBlank(value)) !== 0
            )
            .required('general_requiredField_errorMessage')
        : schema.notRequired()
  ),
  embossedNameOther: Yup.string().when(
    'isCardDigital',
    (isCardDigital: Yup.BooleanSchema, schema: Yup.StringSchema) =>
      isCardDigital ? schema.notRequired() : schema.required('general_requiredField_errorMessage')
  ),
  isNoNameCard: Yup.bool(),
  noNameCardId: Yup.string().when(
    'isNoNameCard',
    (isNoNameCard: Yup.BooleanSchema, schema: Yup.StringSchema) =>
      isNoNameCard ? schema.required('general_requiredField_errorMessage') : schema.notRequired()
  ),
  lastFourDigits: Yup.string().when(
    'isNoNameCard',
    (isNoNameCard: Yup.BooleanSchema, schema: Yup.StringSchema) =>
      isNoNameCard ? schema.required('general_requiredField_errorMessage') : schema.notRequired()
  ),
});
